<template>
  <div class="wrapper-warning-responsible modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.WARNING
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <div
        data-cy="WARNING_MESSAGE"
        class="has-text-color-8 spacing-px-30 py-20 has-text-weight-semibold"
      >
        {{ General.MESSAGES.WARNING_RESPONSIBLE }}
      </div>

      <div class="process-table">
        <b-table :data="listProcess">
          <b-table-column v-slot="props" :label="General.NUP">
            <span class="has-text-color-7">
              {{ applyMaskNUP(props.row.nup) }}
            </span>
          </b-table-column>
          <b-table-column v-slot="props" :label="General.SUBJECT">
            <span class="has-text-color-7">
              {{ props.row.subject.name }}
            </span>
          </b-table-column>
        </b-table>
      </div>

      <footer class="modal-card-foot is-align-self-flex-end">
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            class="is-medium"
            @click="confirmAction"
          >
            {{ General.YES.toUpperCase() }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-warning'"
            class="is-medium"
            outlined
            @click="close"
          >
            {{ General.NO.toUpperCase() }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";

export default {
  name: "ModalWarningResponsible",
  props: {
    confirm: {
      type: Function,
      default: () => null
    },

    listProcess: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      General
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  methods: {
    async confirmAction() {
      this.confirm();
      this.close();
    },

    close() {
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  width: auto;
  max-width: 75vw;
  background-color: $color-1;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

table tbody tr:hover {
  background-color: transparent !important;
}
</style>

<style lang="scss">
.wrapper-warning-responsible {
  table tbody tr:hover {
    background-color: transparent !important;
  }
}
</style>
